import { Container, Card, Col, Row, Alert } from "react-bootstrap";
import { ButtonPanels } from "./buttonPannels";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../auth/authSlice";
import { baseURL } from "../../config/service";
import { useEffect, useState } from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import API from '../../services/api';
import {SURVEYS_API_URL} from '../../config/service';
import AllocatedSurveyBusinessUserData from "../usersurveyrequest/allocatedSurveyBusinessUserData";


export const HomePageBanner = (props) => {
  const surveys = props.surveys || [];
  const external = props.external;
  const [bannerShow, setbannerShow] = useState(false);
  const [bannerMessage, setbannerMessage] = useState("");
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const groups = user.groups;
  let businessadmin;
  let businessuser;
  let cso;
  let externaluser;

  useEffect(() => {
    if (!businessuser) return; // Exit early if not business user
    
    if (surveys.length === 0) {
      setbannerShow(true);
      setbannerMessage(`Welcome to Security Deposit Portal\n
      If this is your first time signing in, no surveys have been assigned to you by default.\n
      To request a new survey, please use the "Request Survey" dropdown on the left side of the screen.`);
    } else {
      setbannerShow(false);
    }
  }, [businessuser, surveys.length]);
  
  useEffect(() => {
    fetchData();
  },[]);

  if (groups.includes("CSO_ADMINS") || groups.includes("CSO_USERS")) {
    cso = true;
  }
  if (groups.includes("BUSINESS_ADMINS")) {
    businessadmin = true;
  }
  if (groups.includes("BUSINESS_USERS")) {
    businessuser = true;
  }
  if (groups.includes("EXTERNAL_USERS")) {
    externaluser = true;
  }

  async function fetchData() {
    try {
      const response = await API.get(`${SURVEYS_API_URL}/v1/surveys/eqportal/`);
      return response.data;
    } catch (error) {
      console.error("Fetch error:", error);
  
      if (!navigator.onLine) {
        // User is offline
        setbannerMessage(
          "You're offline. Please check your internet connection."
        );
      } else if (!error.response) {
        // No response at all: server down, CORS error, DNS fail, etc.
        setbannerMessage(
          "Welcome to Security Deposit Portal \n If no survey is listed below or in the dropdown, this may be due to a network error or a restriction on the portal domain. In this case, please contact your IT department to ensure the domain is whitelisted."
        );
      } else {
        setbannerMessage(
          `Welcome to Security Deposit Portal \n Unable to fetch data from server. Please contact your IT department`
        );
      }
      setbannerShow(true);
    }
  }
  
  return (
    <>
{(businessadmin || businessuser || externaluser) && !external &&(
  <>
    <Row style={{ paddingBottom: "50px", margin:"0"}}>
      {bannerShow && (
        <Col xs={12} lg={9} className="d-flex align-items-center">
          <Container className="d-flex justify-content-start" style={{margin:"0"}}>
            <Alert
              variant="warning"
              className="d-flex align-items-center p-3 shadow-lg w-100"
            >
              <h3 style={{ textAlign: "right", float: "right" }}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </h3>
              <strong>{bannerMessage}</strong>
            </Alert>
          </Container>
        </Col>
      )}

      <Col className="d-flex justify-content-end">
        <Container className="d-flex justify-content-end" style={{margin:"0"}}>
          <ButtonPanels />
        </Container>
      </Col>
    </Row>

    {(businessuser && !businessadmin) && (
      <Row style={{paddingBottom:"50px"}}>
        <AllocatedSurveyBusinessUserData/>
      </Row>
    )}
  </>
)}

{(cso || external) && bannerShow && (
  <Container>
    <Row className="d-flex justify-content-between" style={{ paddingBottom: "20px" }}>
      <Col xs={12} lg={9} className="d-flex align-items-center">
        <Alert
          variant="warning"
          className="d-flex align-items-center p-3 shadow-lg w-100"
        >
          <h3 style={{ textAlign: "right", float: "right" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </h3>
          <strong>{bannerMessage}</strong>
        </Alert>
      </Col>
    </Row>
  </Container>
)}

    </>
  );
};
export default HomePageBanner;